import styled from 'styled-components'
import config from '../../config'

export const PageStyle = styled.div`
  background-image: url('${config.assets.gallerium}');
  background-size: cover;
  padding-top: 30px; // 30px notice bar
  height: 100vh;
  overflow: scroll;
  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    height: 100%;
    display: grid;
    grid-template-columns: minmax(280px, 25%) 1fr;
  }
  .page-content {
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.2);
    display: grid;
    grid-template-rows: 80px 1fr; // 80px header
    /* padding-right: 65px; // right navbar */
    .grid-container {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fill, 200px);
      margin: 20px 60px;
      grid-auto-rows: max-content;
    }
    // header
    .back-btn {
      backdrop-filter: blur(22px);
      background-color: rgba(255, 255, 255, 0.3);
      font-weight: bold;
      color: #f85d49;
      display: flex;
      align-items: center;
      text-decoration: none;
      padding: 20px 30px;
      .back-icon {
        cursor: pointer;
        display: flex;
        width: 30px;
        flex-direction: column;
        img,
        svg {
          transition: 100ms linear;
          height: 24px;
        }
        .icon-label {
          transition: 100ms linear;
          text-align: left;
          font-size: 1px;
          opacity: 0;
        }
        &:hover {
          img,
          svg {
            transform: scale(0.5);
          }
          .icon-label {
            font-size: 8px;
            opacity: 1;
          }
        }
      }
      span {
        font-size: 24px;
        font-style: italic;
        margin-left: 1em;
        color: #f85d49;
      }
    }
  }
  .page-sidebar {
    color: white;
    font-size: 20px;
    padding: 0 30px;
    position: relative;
    .page-title {
      width: 100%;
      position: sticky;
      top: 40%;
      h2 {
        text-align: center;
        font-weight: 600;
        font-size: 30px;
      }
    }
  }
  .card-thumbnail {
    display: block;
    cursor: pointer;
    position: relative;
    text-align: center;
    color: black;
    font-weight: 600;
    text-decoration: none;
    font-size: 18px;
    img {
      transition: 150ms ease-in;
      border-radius: 18px;
      width: 90%;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      margin-bottom: 20px;
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
`
